import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Modal               from 'app/components/common/modal';
import RadioButton         from 'app/components/common/radio-button';
import CadminEmployeesDuck from 'app/ducks/company-admin/employees';
import helpers             from 'app/helpers/employees';
import AuthSlx             from 'app/selectors/auth';
import CadminSlx           from 'app/selectors/company-admin/';

const {Roles} = helpers;

const roleOptAdmin = {
  role: Roles.ADMIN,
  label: helpers.roleLabel(Roles.ADMIN),
  description: <p>Access to all admin tools. This is the highest level of access.<br />Email Notifications: match pending, match inquiries, receipts.</p>,
};
const roleOptChampion = {
  role: Roles.CHAMPION,
  label: helpers.roleLabel(Roles.CHAMPION),
  description: <p>Access to creating, editing, and managing campaigns, brackets, and volunteer events.</p>,
};
const roleOptGroups = {
  role: Roles.GROUP_LEAD,
  label: helpers.roleLabel(Roles.GROUP_LEAD),
  description: <p>Access to creating, editing, and managing groups, campaigns, brackets, and events.</p>,
};
const roleOptFinance = {
  role: Roles.FINANCE,
  label: helpers.roleLabel(Roles.FINANCE),
  description: <p>Access to all billing features, including the company wallet and transactions tab.<br />Email notifications: receipts.</p>,
};
const roleOptIt = {
  role: Roles.IT,
  label: helpers.roleLabel(Roles.IT),
  description: <p>Access to SSO/SCIM, integrations, custom attributes, & (limited) employee management.<br />Can assign roles excluding All-Access Admin and Finance.</p>,
};
const roleOptEmp = {
  role: Roles.EMPLOYEE,
  label: helpers.roleLabel(Roles.EMPLOYEE),
  description: <p>No admin access.</p>,
};

const roleOpts          = [roleOptAdmin, roleOptIt,                roleOptChampion, roleOptFinance, roleOptEmp];
const roleOptsWithGroup = [roleOptAdmin, roleOptIt, roleOptGroups, roleOptChampion, roleOptFinance, roleOptEmp];

class ModalEditRole extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      selectedRole: Roles.EMPLOYEE,
    };

    this.onChangeRole = this.onChangeRole.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  get roleOpts() {
    const { company } = this.props;
    return company.features.groups ? roleOptsWithGroup : roleOpts;
  }

  get disabledRoles() {
    return this.cuIsAdmin ? [] : [Roles.ADMIN, Roles.FINANCE];
  }

  get cuRole() {
    const cu = this.props.currentUser;
    if (cu.backstageRole === 'super') return Roles.ADMIN;
    return cu.employment?.employee?.role || Roles.EMPLOYEE;
  }
  get cuIsAdmin() {
    return this.cuRole === Roles.ADMIN;
  }
  get canEdit() {
    if (this.cuIsAdmin) return true;
    const currentRole = this.props.employee.role;
    return !this.disabledRoles.includes(currentRole);
  }

  componentDidMount() {
    this.setState({selectedRole: this.props.employee.role});
  }

  onChangeRole(event) {
    this.setState({selectedRole: event.target.value});
  }

  onCloseModal() {
    this.props.onClose();
  }

  onClickSave() {
    const {company, employee, updateRole, onClose} = this.props;
    const role = this.state.selectedRole;
    updateRole(company.id, employee.id, role);
    onClose();
  }

  render() {
    const { employee } = this.props;
    const { selectedRole } = this.state;

    return (
      <Modal className="modal-emp-role" onClose={this.onCloseModal}>
        <div className="modal-emp-role-body">
          <h1 className="modal-emp-role-title">Manage Permissions</h1>
          <div className="modal-emp-role-emp">
            <div>{`${employee.firstName} ${employee.lastName}`}</div>
            <div>{employee.email}</div>
          </div>
          {this.roleOpts.map((opt) => {
            const isDisabled = !this.canEdit || this.disabledRoles.includes(opt.role);
            const id = `role-opt-${opt.role}`;
            const isSelected = selectedRole === opt.role;
            return (
              <div key={opt.role} className={`modal-emp-role-option ${isSelected ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}>
                <RadioButton name="role" value={opt.role} id={id} checked={isSelected} onChange={this.onChangeRole} disabled={isDisabled} />
                <label htmlFor={id}>
                  <strong>{opt.label}</strong>
                  {opt.description}
                </label>
              </div>
            );
          })}
          <div className="modal-emp-role-actions">
            <button className="btn blue" onClick={this.onClickSave} disabled={!this.canEdit}>Save</button>
          </div>
        </div>
      </Modal>
    );
  }

}

ModalEditRole.propTypes = {
  onClose: PropTypes.func.isRequired,
  employee: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
};

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  currentUser: AuthSlx.currentUser(state),
});

const dispatchToProps = (dispatch) => ({
  updateRole: (companyId, employeeId, role) => dispatch(CadminEmployeesDuck.Ax.updateRole(companyId, employeeId, role)),
});

export default connect(stateToProps, dispatchToProps)(ModalEditRole);
